import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import "./hintTooltip.scss";

/**
 * An explanation shown on hover, written right to left, one line per point.
 *
 * The browser's own `title` tooltip does not follow the page: the dashboard
 * sets right to left with a class on <body>, not with `dir` on <html>, so a
 * native tooltip wraps Arabic as left-to-right text, with its punctuation on
 * the wrong side (the owner, 2026-09-27). This tooltip is part of the page, so
 * it is right to left, and each entry of `lines` is its own line.
 *
 * The child must be one DOM element (a span, a div, a button, a cell): the
 * overlay attaches its ref and its hover handlers to it.
 *
 * @param {{lines: string[], children: import("react").ReactElement, placement?: string}} props
 */
const HintTooltip = ({ lines, children, placement = "top" }) => (
    <OverlayTrigger
        placement={placement}
        delay={{ show: 150, hide: 0 }}
        overlay={
            <Tooltip className="hint-tooltip">
                <div dir="rtl">
                    {lines.map((line) => (
                        <p key={line}>{line}</p>
                    ))}
                </div>
            </Tooltip>
        }
    >
        {children}
    </OverlayTrigger>
);

export default HintTooltip;
